export default __webpack_public_path__ + "static/media/processSteps.2d002df1.svg";